export const SearchDisabledPrivateGroup = "jSa";
export const archiveMailboxFoldersSearchPlaceholder = "kSa";
export default {SearchDisabledPrivateGroup,archiveMailboxFoldersSearchPlaceholder};